import { render, staticRenderFns } from "./NewBucket.vue?vue&type=template&id=3090c004&"
import script from "./NewBucket.vue?vue&type=script&lang=js&"
export * from "./NewBucket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports